import { dimensionCategoriesEntriesSelector } from "./dimensionCategoriesEntriesSelector";
import { RootState } from "@/store/store";

export const dimensionCategoriesLengthSelector = (state: RootState) => {
  const categories = dimensionCategoriesEntriesSelector(state);

  return categories.length;
};
